import { Injectable, signal } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';

interface ActivityNotificationMessage {
    activityType: string;
    title: string;
    message: string;
    page?: string | null;
    triggeredBy?: string | null;
    correlationId: string;
    occurredAtUtc: string;
    details?: string | null;
    runId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class NotificationAlertService {
    readonly unreadCount = signal(0);

    private readonly hubUrl = `${environment.companyApiUrl}/hubs/notifications`;
    private readonly eventName = 'ActivityCompleted';
    private connection?: signalR.HubConnection;
    private started = false;

    constructor(private readonly messageService: MessageService) {}

    start() {
        if (this.started) {
            return;
        }

        this.connection = new signalR.HubConnectionBuilder().withUrl(this.hubUrl).withAutomaticReconnect().build();
        this.connection.on(this.eventName, (payload: ActivityNotificationMessage) => {
            this.unreadCount.update((value) => value + 1);
            this.messageService.add({
                key: 'smart-alert',
                severity: 'info',
                summary: payload.title ?? 'Activity Completed',
                detail: payload.message ?? payload.activityType,
                life: 6000
            });
        });

        this.connection
            .start()
            .then(() => {
                this.started = true;
            })
            .catch((error) => {
                console.error('Unable to start smart alert SignalR connection.', error);
            });
    }

    async stop() {
        if (!this.connection) {
            return;
        }

        await this.connection.stop();
        this.connection = undefined;
        this.started = false;
    }

    clearUnread() {
        this.unreadCount.set(0);
    }
}
